import { AxiosInstance } from 'axios';

import { ActivitiesCategoryColumnsEnum } from '../../enum/activitiesCategoryColumns.enum';
import { ActivityCategory, DeleteItemsInput } from '../../types';
import { PaginationRequest } from '../../types/PaginationRequest';
import { SortRequest } from '../../types/SortRequest';
import { activityCategoriesEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

import { CategoriesResponse, CreateActivityCategoryInput } from './ActivityCategoriesApi.schema';

class ActivityCategoriesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (category: CreateActivityCategoryInput): Promise<ActivityCategory> => {
    return this.#requestInstance.post(activityCategoriesEndpoints.activityCategory, category);
  };

  getCategories = async (
    data?: PaginationRequest & SortRequest<ActivitiesCategoryColumnsEnum>
  ): Promise<CategoriesResponse> => {
    return this.#requestInstance.get(activityCategoriesEndpoints.activityCategoryGet(), {
      params: data,
    });
  };

  deleteCategory = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(activityCategoriesEndpoints.getActivityCategoryById(id));
  };

  getCategoryById = async (id: number): Promise<ActivityCategory> => {
    return this.#requestInstance.get(activityCategoriesEndpoints.getActivityCategoryById(id));
  };

  updateCategory = async (input: ActivityCategory): Promise<ActivityCategory> => {
    return this.#requestInstance.patch(
      activityCategoriesEndpoints.getActivityCategoryById(input?.id),
      input
    );
  };

  deleteMany = async (ids: DeleteItemsInput): Promise<void> => {
    return this.#requestInstance.delete(activityCategoriesEndpoints.activityCategory, {
      data: ids,
    });
  };
}

export const activityCategoriesApi = new ActivityCategoriesApi(axios);
